import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';

const StyledViableInstallmentBox = styled.div<{ selected: boolean; borderColor: string }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${({ borderColor }) => `border: 1px solid ${borderColor};`};
  ${({ selected, theme }) =>
    selected && `color: #ffffff; background-color: ${theme.primary.color.normal}`};
  margin: 0 0.5rem 0.5rem 0;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 3px;
  font-size: 0.9375rem;
  line-height: 2.5rem;
  cursor: pointer;
  &&:last-of-type {
    margin-right: 0;
  }
`;

export interface ViableInstallmentBoxProps {
  /** Flag indicating if the box is selected. */
  isSelected: boolean;
  /** On change handler for selection change. */
  onChange: () => void;
  /** The value of viable installments. */
  value: number;
  /** Border color string. */
  borderColor: string;
}

export const ViableInstallmentBox: FunctionComponent<ViableInstallmentBoxProps> = ({
  isSelected,
  onChange,
  value,
  borderColor,
}): ReactElement => (
  <StyledViableInstallmentBox
    data-testid="viable-installment-box"
    onClick={onChange}
    selected={isSelected}
    borderColor={borderColor}
  >
    {value}
  </StyledViableInstallmentBox>
);

export default ViableInstallmentBox;
